import React from 'react';

import { useTranslation } from 'react-i18next';

import { ReactComponent as ExternalLinkIcon } from '@pkg/assets/icons/v2/nft-manager-external.svg';

import { Interior, MissingNftsActionWrapper } from './styles';

export interface MissingNftsActionProps {
    url?: string;
}

const DEFAULT_URL =
    'https://support.y.at/hc/en-us/articles/8629426499483-Why-is-some-of-the-metadata-missing-from-my-NFT-on-my-Yat-page-';

export function MissingNftsAction({ url = DEFAULT_URL }: MissingNftsActionProps) {
    const { t: translate } = useTranslation(['yat_nft_manager']);

    return (
        <MissingNftsActionWrapper>
            <a href={url} target="_blank" rel="noopener noreferrer">
                <Interior>
                    {translate('yat_nft_manager_dont_see_nfts')}
                    <ExternalLinkIcon />
                </Interior>
            </a>
        </MissingNftsActionWrapper>
    );
}
